import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from './Icon'
import zIndex from '../../utils/zIndexScale'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  .inputWrap {
    position: relative;
    z-index: ${zIndex.input};
  }
  input {
    border: none;
    width: 100%;
    height: 100%;
    outline: none;
    font-size: 14px;
    /* border-bottom: 1px solid rgba(234,236,239,0.5); */
    caret-color: #f0b90b;
    color: ${({ theme }) => theme.inputColor};
    background: inherit;
    padding: 5px 0 10px;
    &:focus {
      /* border-color: #f0b90b; */
    }
    &::-webkit-input-placeholder {
      /* stylelint-disable-line */
      font-size: 14px;
      color: #848e9c;
      font-weight: normal;
    }
  }
  .border-bottom {
    width: 100%;
    height: 1px;
    background: rgba(234, 236, 239, 0.5);
    position: absolute;
    bottom: 0;
    transition: background 0.2s ease;
  }
  input:focus + .border-bottom {
    background: #f0b90b;
  }
  .label {
    font-size: 14px;
    position: absolute;
    transform: translateY(0px);
    z-index: ${zIndex.inputLabel};
    transition: all 0.2s ease;
    color: #848e9c;
  }
  .label-value {
    transform: translateY(-15px);
    font-size: 14px;
    color: ${({ theme }) => theme.fontColor};
  }
`

const Clear = styled.div`
  position: absolute;
  right: 0px;
  bottom: 10px;
  color: ${({ theme }) => theme.fontColor};
  cursor: pointer;
`

class Input extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    type: PropTypes.string,
    title: PropTypes.string,
    defaultValue: PropTypes.string,
    value: PropTypes.string,
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
  }

  static defaultProps = {
    onChange: () => {},
    title: '',
    type: 'text',
    value: '',
    defaultValue: '',
    autoFocus: false,
    className: undefined,
  }

  constructor(props) {
    super(props)
    this.state = {
      value: props.defaultValue,
    }
  }

  componentDidUpdate(prevProps) {
    const { defaultValue } = this.props
    const { value } = this.state
    if (prevProps.defaultValue !== defaultValue && parseFloat(value) !== parseFloat(defaultValue)) {
      /* eslint-disable-next-line */
      this.setState({ value: defaultValue })
    }
  }

  _clear = () => {
    const { onChange } = this.props
    this.setState({ value: '' }, () => {
      onChange('', false)
    })
  }

  _getDecimal = value => {
    const { type } = this.props
    if (type !== 'number') return 0
    if (!value) return 0
    if (!value.includes('.')) return 0

    return value.split('.')[1].length
  }

  _textChange = e => {
    const { onChange, type } = this.props
    let { value } = this.state

    const newValue = type === 'text' ? e.currentTarget.value : e.currentTarget.value.trim()
    const decimal = this._getDecimal(newValue)
    if (decimal <= 8) {
      value = newValue
    }
    this.setState({ value }, () => {
      onChange(value)
    })
  }

  render() {
    const { value } = this.state
    const { title, defaultValue, type, autoFocus, className } = this.props

    return (
      <Wrapper className={className}>
        <p className={value || defaultValue ? 'label label-value' : 'label'}>{title}</p>
        <div className="inputWrap">
          <input
            type={type}
            // placeholder={title}
            value={value}
            /* eslint-disable-next-line */
            autoFocus={autoFocus}
            onChange={this._textChange}
          />
          <div className="border-bottom" />
          {(!!value || !!defaultValue) && (
            <Clear onClick={this._clear}>
              <Icon type="clear" size="14" />
            </Clear>
          )}
        </div>
      </Wrapper>
    )
  }
}

export default Input
